<template>
  <div class="content" onselectstart="return false">
    <div class="statistics">
      <div class="total" @click="_open">
        <div class="totalimg"></div>
        <div class="totalnum">{{ deviceNumber.totalCount }}</div>
      </div>
      <div
        :class="isOpen ? 'deviceApplication' : 'isShow'"
        v-for="i in deviceNumber.list"
      >
        <div class="applicationImg">
          <span><i :class="'iconfont ' + i.icon"></i></span>
        </div>
        <div class="applicationTxt">
          <div class="applicationnNum">
            <i>{{ i.onlineCount }}</i
            ><i>/{{ i.counts }}</i>
          </div>
          <p>{{ i.name }}</p>
        </div>
      </div>
    </div>
    <div class="detail" v-if="isDetail">
      <div class="closeDetail" @click="_closeDetail"><i class="iconfont iconright"></i></div>
      <header>
        <div class="title">
          {{ deviceList.deviceName }}
          <span :class="deviceList.status !== 1 ? 'iActive' : ''"
            ><i></i>{{ deviceList.deviceStatusName }}</span
          >
        </div>
        <div class="detailContent">
          <div class="deviceIcon">
            <span><i :class="'iconfont ' + (deviceList.icon || 'iconweidingyi-')"></i></span>
          </div>
          <div>
              <p>设备编码：{{ deviceList.device_mark || deviceList.deviceId }}</p>
              <p>当前区域：{{ deviceList.region || deviceList.address}}</p>
          </div>
        </div>
      </header>
      <div class="device">
        <div class="deviceList" v-for="item in deviceData">
          <div class="bg">{{ item.dataflowUnit }}</div>
          <h6>{{ item.dataflowName }}</h6>
          <p>{{ item.dataflowData }} {{ item.dataflowUnit }}</p>
        </div>
      </div>
      <div class="information">
        <el-tabs v-model="activeName">
          <el-tab-pane label="报警信息" name="first">
            <div class="searchTime">
              <el-date-picker
                v-model="startTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="请选择开始时间"
              >
              </el-date-picker>
              -
              <el-date-picker
                v-model="endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择结束时间"
              >
              </el-date-picker>
              <div class="searchSubmit" @click="_searchSubmit">
                <i style="color: #2f82b7" class="el-icon-search"></i>
              </div>
            </div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="startTime" label="报警时间" width="180">
              </el-table-column>
              <el-table-column prop="alarmDesc" label="报警内容">
              </el-table-column>
              <el-table-column label="操作" width="100" align="left">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.alarmStatus !== 4"
                    type="warning"
                    size="small"
                    >未处理</el-tag
                  >
                  <el-tag v-else type="success" size="small">已处理</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="事件信息" name="second">
            <div class="searchTime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="startTime1"
                type="date"
                placeholder="请选择开始时间"
              >
              </el-date-picker>
              -
              <el-date-picker
                v-model="endTime1"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择结束时间"
              >
              </el-date-picker>
              <div class="searchSubmit" @click="_searchSubmit1">
                <i style="color: #2f82b7" class="el-icon-search"></i>
              </div>
            </div>
            <el-table :data="eventData" style="width: 100%">
              <el-table-column
                prop="eventTypeName"
                label="事件名称"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="eventContent" label="事件内容">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="leftTree">
      <ul>
        <li
          :class="{ treeActive: treeActive === index }"
          v-for="(i, index) in treeData"
          @click="_treeClick(index)"
        >
          {{ i.value }}
        </li>
      </ul>
    </div>
    <div class="list">
      <ul>
        <li :class="treeIsShow ? '' : 'isShow'">
          <tree
            :props="{ label: 'name', children: 'areas' }"
            :data="treeList"
            @handleNodeClick="_leafSelect"
            ref="region"
          ></tree>
        </li>
        <!--        应用系统-->
        <li :class="sysIsShow ? '' : 'isShow'" class="application">
          <div class="nav">
            <div @click="_checkSysAll" class="allList">
              <i class="el-icon-finished"></i>
            </div>
            <div>应用系统</div>
            <span @click="_showListBox" :class="!showIcon ? 'spanActive' : ''"
              ><i class="el-icon-s-unfold"></i></span
            ><span @click="_showIconList" :class="!showIcon ? '' : 'spanActive'"
              ><i class="el-icon-menu"></i
            ></span>
          </div>
          <ul class="listBox" v-if="showIcon">
            <li
              v-for="(i, index) in systemArr"
              :key="i.id"
            >
              <input
                type="checkbox"
                ref="checkDom"
                :id="'s_checkbox' + index"
                @click="_checkedSys(i, index, 1)"
              />
              <label :for="'s_checkbox' + index">{{ i.name }}</label>
            </li>
          </ul>
          <ul class="iconList" v-else>
            <li
              :class="{ iconListActive: iconListActive === index }"
              v-for="(i, index) in systemArr"
              :key="i.id"
              @click.stop="_checkedSys(i, index, 2)"
            >
              <span><i class="el-icon-check"></i></span>
              <div>
                <i
                  :class="i.icon ? 'iconfont ' + i.icon : 'iconweidingyi-'"
                ></i>
              </div>
              <p>{{ i.name }}</p>
            </li>
          </ul>
        </li>
        <!--        设备类型-->
        <li :class="deviceIsShow ? '' : 'isShow'" class="application">
          <div class="nav">
            <div @click="_checkDeviceAll" class="allList">
              <i class="el-icon-finished"></i>
            </div>
            <div>设备类型</div>
            <span @click="_showListBox1" :class="!showIcon1 ? 'spanActive' : ''"
              ><i class="el-icon-s-unfold"></i></span
            ><span
              @click="_showIconList1"
              :class="!showIcon1 ? '' : 'spanActive'"
              ><i class="el-icon-menu"></i
            ></span>
          </div>
          <ul class="listBox" v-if="showIcon1">
            <li
              v-for="(i, index) in deviceTypeList"
              :key="index"
            >
              <input type="checkbox" :id="'t_checkbox1'+index"  ref="checkDeviceDom" @click="_checkDevice(i, index,1)"/>
              <label :for="'t_checkbox1' + index">{{i.typeName }}</label>
            </li>
          </ul>
          <ul class="iconList" v-else>
            <li
              :class="{ iconListActive: iconListActive1 === index }"
              v-for="(i, index) in deviceTypeList"
              :key="i.id"
              @click.stop.prevent="_checkDevice(i, index, 2)"
            >
              <span><i class="el-icon-check"></i></span>
              <div>
                <i :class="'iconfont ' + i.icon"></i>
              </div>
              <p>{{ i.typeName }}</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <section class="map" ref="map">
      <div class="mapBox">
        <mp
          v-if="rootData && model === 0"
          :data="rootData"
          :deviceType="deviceType"
          :systemId="systemId"
          @deviceInfo="deviceInfo"
        ></mp>
        <displays
          v-if="model === 1"
          :areaIds="areaId"
          :imgUrl="imgUrl"
          :initResult="rootData"
          :deviceType="deviceType"
          :systemId="systemId"
          @deviceInfo="deviceInfo"
        ></displays>
        <feng-map
          v-if="model === 2"
          :areaId="areaId"
          :ctrl-position="1"
          :ctrl-offset="{ x: 100, y: 380 }"
          :device-type="checkDeviceType"
          @showDetail="showDetail"
        ></feng-map>
      </div>
    </section>
  </div>
</template>

<script>
import { obj2urlsp } from "../../../utils/";
// import Index from "../systemConfiguration/first/system/emergencyDisposal";
export default {
  data() {
    return {
      checked: false,
      isDetail: false, // 是否展示设备信息
      iconListActive: "",
      iconListActive1: "",
      checkList: [],
      treeData: [
        { id: 0, value: "区域" },
        { id: 1, value: "应用系统" },
        { id: 2, value: "设备类型" },
      ],
      treeIsShow: false, // 区域树是否展示
      sysIsShow: false, // 应用列表是否展示
      deviceIsShow: false, // 设备列表是否展示
      treeActive: "", // 当前选中的
      isOpen: false, // 是否展开
      startTime: "", // 设备详情查询开始时间
      endTime: "", // 设备详情查询结束时间
      startTime1: "",
      endTime1: "",
      tableData: [], // 报警信息列表
      eventData: [], // 事件信息列表
      activeName: "first",
      positionX: 0,
      positionY: 0,
      rootData: [], // 地图
      searchDev: 0,
      systemArr: [], // 应用系统列表
      deviceTypeListAll: [], // 全部设备类型
      deviceTypeList: [], // 设备类型列表
      deviceNumber: {}, // 设备数量
      showIcon: true, // 展示图标
      showIcon1: true,
      treeList: [], // 区域树列表
      deviceList: [], // 设备信息
      deviceData: [], // 设备详情最新的设备数据
      type: true, // 是否是安装点
      model: 0, // 是平面图还是地图
      imgUrl: "", // 平面图
      areaId: "", // 平面图
      deviceType: null, // 当前选中的设备类型id
      systemId: null, // 当前选中的应用系统id，
      checkDeviceType: [],
      inputMark:true,
    };
  },
  components: {
    mp: () => import("./aMap"),
    search: () => import("./search"),
    tree: () => import("./tree"),
    displays: () => import("./displayb"),
    fengMap: () => import("../../../components/public/fmap"),
  },
  watch: {
    deviceTypeList() {
      if (this.deviceTypeList && this.deviceTypeList.length) {
        this.checkDeviceType = [];
        this.deviceTypeList.forEach((it) => {
          this.checkDeviceType.push(it.typeName);
        });
      }
    },
    deviceType() {
      if (this.deviceType) {
        this.checkDeviceType = [];
        let t = this.deviceTypeList.find((it) => it.id === this.deviceType);
        if (t) this.checkDeviceType.push(t.typeName);
      }
    },
  },
  methods: {
    // 关闭详情
    _closeDetail(){
      this.isDetail = false
    },
    // 报警信息搜索
    _searchSubmit() {
      let data = {
        startTime: this.startTime,
        endTime: this.endTime ? this.endTime + " 23:59:59" : "",
        deviceId: this.deviceList.device_mark,
      };
      this._deviceAlarm(data);
    },
    // 峰鸟设备信息
    showDetail(areaId, id) {
      this.$axiospost(
        "extra/deviceRelation/device",
        obj2urlsp({
          areaId: areaId,
          pointId: id,
        })
      ).then((res) => {
        if (res.data.status === "-10000") {
        } else {
          this.isDetail = true;
          this.deviceList = res.data.data;
          this._deviceAlarm({ deviceId: this.deviceList.id });
          this._deviceEvent();
          this.$axiosget(
            "taos/taosdata/query_latest?id=" +
              this.deviceList.id +
              "&typeId=" +
              this.deviceList.deviceType
          ).then((res) => {
            this.deviceData = res.data.data;
          });
        }
      });
    },
    // 设备信息
    deviceInfo(e) {
      if (e === "close") {
        this.isDetail = false;
      } else {
        this.deviceList = e;
        this.isDetail = true;
        this._deviceAlarm({ deviceId: this.deviceList.id });
        this._deviceEvent();
        this.$axiosget(
          "taos/taosdata/query_latest?id=" + e.id + "&typeId=" + e.deviceType
        ).then((res) => {
          this.deviceData = res.data.data;
        });
      }
    },
    // 列表图标切换
    _showListBox() {
      this.showIcon = true;
      this.$nextTick(()=>{
        if (this.$refs.checkDom[this.iconListActive])
          this.$refs.checkDom[this.iconListActive].checked = true
      })
    },
    _showIconList() {
      this.showIcon = false;
    },
    _showListBox1() {
      this.showIcon1 = true;
      this.$nextTick(()=>{
        if (this.$refs.checkDeviceDom[this.iconListActive1])
          this.$refs.checkDeviceDom[this.iconListActive1].checked = true
      })
    },
    _showIconList1() {
      this.showIcon1 = false;
    },

    // 报警信息
    _deviceAlarm(data) {
      this.$axiospost(
        "operation/deviceAlarmApi/getAlarmNowPageList",
        data
      ).then((res) => {
        this.tableData = res.data.data.list;
      });
    },
    // 事件信息搜索
    _searchSubmit1() {
      this.endTime1 = this.endTime1 ? this.endTime1 : "";
      let params = {
        startTime1: this.startTime1,
        endTime1: this.endTime1 ? this.endTime1 + " 23:59:59" : "",
        deviceId: this.deviceList.device_mark,
      };
      this.$axiosget("extra/deviceEvent/page?", { params }).then((res) => {
        this.eventData = res.data.data.list;
      });
    },
    //  事件信息
    _deviceEvent() {
      this.$axiosget(
        "extra/deviceEvent/page?deviceId=" + this.deviceList.id
      ).then((res) => {
        this.eventData = res.data.data.list;
      });
    },
    // 设备类型
    _checkDevice(e, index, f) {
      // f 1是列表 2 是图标
      // 单选
      if (f === 1) {
        this.iconListActive1 = index
        this.$refs.checkDeviceDom.map((item, i) => {
          if (index !== i) {
            item.checked = false;
          } else {
            if (!item.checked) {
              this.deviceType = null;
              this._getDeviceNumber(this.areaId, this.systemId);
            }
          }
        });
        if (this.$refs.checkDeviceDom[index].checked) {
          this._getDeviceNumber(this.areaId, this.systemId, e.id);
          this.deviceType = e.id;
        }
      } else {
        if (this.iconListActive1 === index) { // 图标未选中
          this._getDeviceNumber(this.areaId, this.systemId);
          this.deviceType = null;
          this.iconListActive1 = "";
        } else {
          this.deviceType = e.id;
          this.iconListActive1 = index;
          this._getDeviceNumber(this.areaId,this.systemId, e.id);
        }
      }
      // todo
    },
    // 全部设备类型
    _checkDeviceAll() {
      this._getDeviceNumber(this.areaId,this.systemId,null);
      this.deviceTypeList = this.deviceTypeListAll;
      this.iconListActive1 = "";
      this.$refs.checkDeviceDom.map((item, i) => {
        item.checked = false;
      });
    },
    // 全部应用系统
    _checkSysAll() {
      this._getSys();
      this._getDeviceNumber(this.areaId);
      this.iconListActive = "";
      this.iconListActive1 = "";
      this.deviceType = null;
      this.systemId = null;
      this.$refs.checkDom.map((item, i) => {
        item.checked = false;
      });
      this.$refs.checkDeviceDom.map((item, i) => {
        item.checked = false;
      });
    },
    _getSys() {
      // 应用系统
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
        {
          params: {
            compayId: localStorage.getItem("companyId"),
          },
        }
      ).then((res) => {
        this.systemArr = res.data.data;
      });
    },
    // 选中的应用
    _checkedSys(e, index, f) {
      if (f === 1) {
        this.iconListActive = index
        // 单选
        this.$refs.checkDom.map((item, i) => {
          if (index !== i) {
            item.checked = false;
          } else {
            if (!item.checked) {
              this.deviceTypeList = this.deviceTypeListAll; // 全部设备类型
              this.iconListActive1 = "";
              this.iconListActive = ''
              this.systemId = null;
              this.deviceType = null;
              this._getDeviceNumber(this.areaId);
              this.$refs.checkDeviceDom.map((item, i) => {
                item.checked = false;
              });
            }
          }
        });
        // 选中查设备类型
        if (this.$refs.checkDom[index].checked) {
          this._getDeviceNumber(this.areaId, e.id, null);
          this.deviceType = null;
          this.iconListActive1 = "";
          this.$refs.checkDeviceDom.map((item, i) => {
            item.checked = false;
          });
          this.systemId = e.id
          this.deviceType = null
          this.iconListActive1 = ''
          // 设备类型筛选
          this.deviceTypeList = this.deviceTypeListAll.filter((item)=>{
            return item.systemId === e.id
          })
        }
      } else {
        if (this.iconListActive === index) { // 图标没选中
          this._getDeviceNumber(this.areaId);
          this.iconListActive1 = "";
          this.iconListActive = "";
          this.systemId = null;
          this.deviceType = null;
          this.$refs.checkDeviceDom.map((item, i) => {
            item.checked = false;
          });
        } else { // 图标选中
          this._getDeviceNumber(this.areaId, e.id, null);
          this.systemId = e.id;
          this.iconListActive = index;
          this.iconListActive1 = "";
          this.deviceType = null;
          // 设备类型筛选
          this.deviceTypeList = this.deviceTypeListAll.filter((item) => {
            return item.systemId === e.id;
          });
        }
      }
    },
    // 选中的树
    _leafSelect(e) {
      this._getDeviceNumber(e.id, this.systemId, this.deviceType);
      this.isDetail = false;
      if (e.model === 0) {
        // 地图
        this.model = 0;
        this.rootData = [];
        if (e.areas.length) {
          e.areas.forEach((item) => {
            if (item.type === 1) {
              this.rootData.push(item);
            }
          });
        }
      } else if (e.model === 1) {
        // 平面图
        this.model = 1;
        this.imgUrl = e.url;
        this.areaId = e.id;
        this.rootData = [];
        if (e.areas.length) {
          e.areas.forEach((item) => {
            if (item.type === 1) {
              this.rootData.push(item);
            }
          });
        }
      } else if (e.model === 2) {
        // 蜂鸟
        this.model = 2;
        this.areaId = e.id;
      }
      if (this.rootData.length == 0) {
        this.rootData.push(e);
      }
    },
    // 应用系统单选
    _treeClick(index) {
      if (index === this.treeActive) {
        this.treeActive = "";
        if (index === 0) {
          this.treeIsShow = !this.treeIsShow;
        } else if (index === 1) {
          this.sysIsShow = !this.sysIsShow;
        } else {
          this.deviceIsShow = !this.deviceIsShow;
        }
      } else {
        this.treeActive = index;
        if (index === 0) {
          this.treeIsShow = true;
        } else {
          this.treeIsShow = false;
        }
        if (index === 1) {
          this.sysIsShow = true;
        } else {
          this.sysIsShow = false;
        }
        if (index === 2) {
          this.deviceIsShow = true;
        } else {
          this.deviceIsShow = false;
        }
      }
    },
    // 展开
    _open() {
      this.isOpen = !this.isOpen
    },
    initMapData() {
      this.$axiosget("operation/area/selectArea").then((res) => {
        this.treeList = res.data.data;
        this.rootData = res.data.data;
        this._leafSelect(res.data.data[0]);
      });
    },
    // 设备统计
    _getDeviceNumber(areaId, systemId, deviceTypeId) {
      let params = {
        companyId: localStorage.getItem("companyId"),
        areaId: areaId,
        systemId: systemId,
        deviceTypeId: deviceTypeId,
      };
      // 设备数量
      this.$axiosget("operation/area/countSystemDevice",{params}).then((res) => {
        this.deviceNumber = res.data.data
      });
    },
    //设备类型
    _getDeviceType() {
      this.$axiosget("manager/devicetype/getTypeByCompanyId", {
        params: {
          companyId: localStorage.getItem("companyId"),
        },
      }).then((res) => {
        this.deviceTypeListAll = res.data.data;
        this.deviceTypeList = res.data.data
      });
    },
  },
  mounted() {
    this._getDeviceType();
    this.initMapData();
    this._getSys();
    this._getDeviceNumber();
  },
};
</script>

<style scoped lang="less">
.content {
  height: 100%;
  position: relative;
}
.isShow {
  display: none;
}
.statistics {
  display: flex;
  position: absolute;
  z-index: 32;
  left: 40px;
  top: 20px;
  height: 125px;
  background: #060f17;
  border: 1px solid #152e42;
  //.open {
  //  cursor: pointer;
  //  position: absolute;
  //  right: -40px;
  //  font-size: 12px;
  //  width: 40px;
  //  height: 20px;
  //  border-radius: 0 2px 2px 0;
  //
  //  text-align: center;
  //  vertical-align: center;
  //  background: #3d2522;
  //  border: 1px solid rgba(246, 117, 22, 0.73);
  //  color: rgba(246, 117, 22, 0.77);
  //}
  //.totalText {
  //  font-family: fantasy;
  //  position: absolute;
  //  top: -4px;
  //  left: -2px;
  //  background: #0c2f45;
  //  font-size: 12px;
  //  color: #066990;
  //  transform: scale(0.8);
  //  width: 20px;
  //  height: 40px;
  //  padding: 5px;
  //}
  .total {
    width: 120px;
    border-right: 1px solid #0f2231;
    text-align: center;
    cursor: pointer;
    .totalimg {
      margin: 10px auto 0;
      width: 70px;
      height: 70px;
      background: url("imgaes/total.png") no-repeat;
      background-size: cover;
    }
    .totalnum {
      color: #36bfff;
      width: 120px;
      font-size: 30px;
      line-height: 40px;
    }
  }
  .deviceApplication {
    width: 200px;
    display: flex;
    border-right: 2px solid;
    border-image: -webkit-linear-gradient(transparent, #1c3b54, transparent) 0 1;
    border-image: -moz-linear-gradient(transparent, #1c3b54, transparent) 0 1;
    border-image: linear-gradient(transparent, #1c3b54, transparent) 0 1;
    .applicationImg {
      margin: 25px 5px 25px 25px;
      line-height: 70px;
      span {
        display: inline-block;
        width: 60px;
        height: 60px;
        background: url("imgaes/electric.png") no-repeat;
        background-size: cover;
        line-height: 60px;
        text-align: center;
        i {
          font-size: 24px;
          color: #00baff;
        }
      }
    }
    .applicationTxt {
      margin-top: 30px;
      .applicationnNum {
        font-family: fantasy;
        font-size: 30px;
        i {
          &:nth-of-type(1) {
            color: #01e794;
          }
          &:nth-of-type(2) {
            color: #00baff;
          }
        }
      }
      p {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
.detail {
  width: 510px;
  padding: 25px;
  position: absolute;
  z-index: 633;
  top: 50px;
  right: 20px;
  background: #0d1424ef;
  overflow: hidden;
  .detailContent{
    padding: 10px;
    display: flex;
    align-items: center;
    .deviceIcon{
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: url("imgaes/electric.png") no-repeat;
        background-size: contain;
          i{
            color:#00b9ff ;
          }
      }
  }
  .closeDetail{
    position: absolute;
    left: 5px;
    top: 50%;
    z-index: 345;
    color: #36bfffb8;
    width: 20px;
    height: 20px;
  }
  header {
    .title {
      width: 100%;
      height: 40px;
      background: url("imgaes/detailHeaderBg.png") no-repeat;
      color: #ccc;
      font-size: 16px;
      padding-left: 15px;
      padding-top: 5px;
      span {
        color: #01ef99;
        float: right;
        i {
          margin-right: 5px;
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50px;
          background-color: #01ef99;
        }
      }
      .iActive {
        color: #ef0101;
        i {
          background-color: #ef0101;
        }
      }
    }
    p {
      padding-left: 20px;
      color: #cacaca;
      font-size: 14px;
      line-height: 40px;
    }
  }
  .device {
    padding-left: 10px;
    display: flex;
    .deviceList {
      margin-right: 20px;
      border: 1px solid #172839;
      width: 120px;
      .bg {
        text-align: center;
        font-size: 18px;
        line-height: 50px;
        color: #00b9ff;
        margin: 10px auto 0;
        width: 50px;
        height: 50px;
        background: url("imgaes/electric.png") no-repeat;
        background-size: contain;
      }
      h6 {
        line-height: 30px;
        color: #61a1c3;
        text-align: center;
      }
      p {
        font-size: 16px;
        text-align: center;
        background: #042236;
        color: #126d9c;
        height: 35px;
        line-height: 35px;
      }
    }
  }
  .information {
    .searchTime {
      height: 60px;
      margin: 15px 0;
      padding: 10px;
      background: #192643;
      .searchSubmit {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        background-color: #283b65;
        text-align: center;
        line-height: 40px;
      }
    }
  }
  /deep/ .el-input__prefix {
    line-height: 40px;
  }
  /deep/ .el-table {
    height: 400px;
    background: #0d1424;
  }
  /deep/ .el-table__body-wrapper {
    max-height: 200px;
    overflow: scroll;
    background-color: #0d1424;
  }
  .el-tag.el-tag--warning {
    color: #f67516;
    border: 1px solid #f67516;
    background: #3d2522;
  }
  .el-tag.el-tag--success {
    background: #0b0e1d;
    border: 1px solid #314081;
    color: #314081;
  }
  /deep/.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 188px;
  }
  /deep/ .el-input__inner {
    background-color: #141f36;
    border-color: #253658;
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: #161f32;
  }
  /deep/ .el-tabs__item {
    color: #ccc;
  }
  /deep/ .el-tabs__header {
    color: #218dd1;
  }
  /deep/ .el-tabs__item.is-active {
    border-bottom: #35b9f7;
  }
  /deep/ .el-table th {
    background: #192643;
    color: #35b9f7;
  }
  /deep/ .el-table tr {
    background: #0d1525;
    color: #98a6c5;
  }
  /deep/.el-table td {
    border-bottom: 1px dashed #ccc;
  }
}

.leftTree {
  position: absolute;
  z-index: 233;
  top: 200px;
  left: 40px;
  ul {
    li {
      color: #cccccc;
      cursor: pointer;
      width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: url("imgaes/treebg.png") no-repeat;
      margin-bottom: 20px;
    }
    .treeActive {
      color: #00bfff;
      background: url("imgaes/treebgactive.png") no-repeat;
    }
  }
}
.list {
  position: absolute;
  z-index: 233;
  top: 200px;
  left: 200px;
  max-height: 600px;
  // overflow: scroll;
  .nav {
    color: #cccccc;
    padding: 0 20px;
    height: 50px;
    background-image: linear-gradient(#062840, #004c78);
    text-align: right;
    line-height: 50px;
    div {
      display: inline-block;
      float: left;
    }
    .allList {
      float: left;
      i {
        margin-right: 10px;
      }
    }
    span {
      display: inline-block;
      font-size: 18px;
      width: 20px;
      line-height: 20px;
      text-align: center;
      color: #1f83e5;
      margin-right: 10px;
    }
    .spanActive {
      color: #6f7275;
    }
  }
  .application {
    width: 280px;
    min-height: 200px;
    background: #02192acf;
    box-sizing: border-box;
    cursor: pointer;
    .listBox {
      max-height: 450px;
      overflow: scroll;
      box-sizing: border-box;
      padding: 10px 20px 20px;
      li {
        // color: #61a1c3;
        color: #c3c3c3;
        line-height: 40px;
        border-bottom: 1px solid #324c60;
        input {
          margin-right: 10px;
        }
      }
    }
    .iconList {
      padding: 20px;
      max-height: 500px;
      overflow: scroll;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        border: 1px solid #324c60;
        position: relative;
        width: 100px;
        height: 100px;
        margin: 10px;
        overflow: hidden;
        span {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          width: 0px;
          height: 0px;
          border: 12px solid;
          border-color: #6fafd9 #6fafd9 transparent transparent;
          i {
            position: absolute;
            top: -13px;
            left: -3px;
          }
        }
        div {
          background: url("imgaes/electric.png");
          width: 45px;
          margin: 15px auto 10px;
          height: 45px;
          text-align: center;
          line-height: 45px;
          i {
            color: #00b6fb;
          }
        }
        p {
          color: #61a1c3;
          font-size: 12px;
          background: #042236;
          line-height: 30px;
          width: 100%;
          text-align: center;
        }
      }
      .iconListActive {
        border-color: #5991b6;
        p {
          background: #163e5e;
          color: #fff;
        }
        span {
          display: inline-block;
        }
      }
    }
  }
  /deep/.el-radio__inner {
    border-radius: 2px;
  }
}
.map {
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 1;
  display: flex;
  .mapBox {
    width: 100%;
    height: 100%;
    .searchBox {
      width: 316px;
      height: 42px;
      position: absolute;
      left: 30px;
      top: 30px;
      z-index: 3;
      border-radius: 3px;
      box-shadow: 2px 2px 15px #d4d4d4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/appMonitorNew/index.vue